(function () {
  'use strict';

  angular
    .module('dashboard.project.overview')
    .directive('reportDataRow', reportDataRow);

  reportDataRow.$inject = [];

  function reportDataRow() {
    var directive = {
      controller: 'reportDataRowCtrl',
      template: require('./report.data.row.html'),
      link: link,
      restrict: 'E',
      replace: true,
      scope: {
        entity: '=',
        isSection: '=',
        isProject: '=',
        isCollapsed: '=',
      },
    };
    return directive;

    function link(scope, element, attrs, ctrl) {}
  }
})();
